<template>
  <div class="card">
    <div class="card-header">
    </div>
    <div class="card-footer">
      <p-button type="info" @click.prevent="callMonoConnect" class="info" round>Link a bank account</p-button>
    </div>

  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {Input, Button, Select, Option} from 'element-ui'

  import Vue from 'vue'

  export default {
    components: {
      [Option.name]: Option,
      [Select.name]: Select,
    },
    computed: {
      ...mapFields(['country', 'bank', 'number'])
    },
    data () {
      return {
        model: {
          country: '',
          bank: '',
          number: '',
          linkAccountButtonText: 'Link Account'
        },
        modelValidations: {
          country: {
            required: true
          },
          bank: {
            required: true
          },
          number: {
            required: true,
          },
        },
        selects: {
          banks: '',
          banksToSelect: [],
          countries: '',
          countriesToSelect: [{value: "NG", label: "Nigeria"}],
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if(isValid){

            this.model.linkAccountButtonText = 'Linking ...'

            this.$http.post('/accounts', {
              bank_id: this.model.bank,
              number: this.model.number 
            })
            .then(response =>{
              this.model.linkAccountButtonText = 'Account Linked '
              this.model.bank = ''
              this.model.number = ''
              this.model.country = ''
            }
            )
            .catch(error => {console.error(error)})
            
          }
        })
      },

      getBanks () {
        this.$http.get('/banks')
          
          .then(response => {
                            
            let banks = response.data
            this.selects.banksToSelect = banks
            
          })
          .catch(err => console.error(err))
        
      },

      callMonoConnect () {
        var connect;
        var config = {
          key: process.env.VUE_APP_MONO_LIVE_PUBLIC_KEY,
          onSuccess: function (response) {
            console.log(JSON.stringify(response))
            console.log(JSON.stringify(response.code))
            
            Vue.prototype.$http.post('/accounts/mono', {
              tempCode: response.code,

            })
            .then(response =>{
              console.log(JSON.stringify(response))
            })
            .catch(error => {console.error(error)})
            
          },
          onClose: function () {
            console.log('user closed the widget.')
          }
        };
        connect = new Connect(config);
        connect.setup()

        connect.open()
      },

      monoScript () {
        let monoScript = document.createElement('script')
        monoScript.setAttribute('src', 'https://connect.withmono.com/connect.js')
        document.head.appendChild(monoScript)
      }
    },

    mounted () {
      this.getBanks ()
      this.monoScript ()
    }
  }
</script>
<style>
  #budgetForm .el-select { display: block  !important;}
</style>
